export default __webpack_public_path__ + "static/media/salesWhite.58526a26.svg";